// utils/colorMap.js
import { COLOR_TITLE_GROUPS } from "./colors";

export const buildTitleColorMap = () => {
  const map = {};
  for (const group of COLOR_TITLE_GROUPS) {
    for (const title of group.titles) {
      map[title] = {
        color: group.color,
        bgColor: group.bgColor
      };
    }
  }
  return map;
};

export const TITLE_COLOR_MAP = buildTitleColorMap();
